var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "seach" },
    [
      _c("el-autocomplete", {
        attrs: {
          size: "small",
          "fetch-suggestions": _vm.querySearchAsync,
          placeholder: "请输入内容",
        },
        on: { select: _vm.handleSelect },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ item }) {
              return [
                _c("div", { staticClass: "name" }, [
                  _vm._v(_vm._s(item.productNameCn) + " "),
                  item.productNameEn
                    ? _c("span", [
                        _vm._v("(" + _vm._s(item.productNameEn) + ")"),
                      ])
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
        model: {
          value: _vm.data.productNameCn,
          callback: function ($$v) {
            _vm.$set(_vm.data, "productNameCn", $$v)
          },
          expression: "data.productNameCn",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }